import { gql } from '@apollo/client';


export const SELLERS = gql`
  query Sellers {
    sellers {
      id
      name
      city
    }
  }
`;

export const ASSETS_FOR_SELECT = gql`
  query Assets($sellerId: ID) {
    assets(
      sellerId: $sellerId
    ) {
      id
      name
    }
  }
`;


export const VALUE_DASHBOARD = gql`
  query ValueDashboard (
    $startOn: ISO8601Date!
    $endOn: ISO8601Date!
    $sellerId: ID
    $assetId: ID
    $feesOnDates: Boolean
    $showOnlySold: Boolean
  ) {
    valueDashboard (
      startOn: $startOn
      endOn: $endOn
      sellerId: $sellerId
      assetId: $assetId
      feesOnDates: $feesOnDates
      showOnlySold: $showOnlySold
    ) {
      assetsListed { id }
      assetsSold { id }
      soldPercentage
      reruns
      totalAssetsWithOneRun
      totalAverageRuns
      totalFees
      totalFeesSold
      salePrice
      buyFeesCount
      buyFeesAmount
      buyFeesExpenses
      buyFeesNet
      buyFees { 
        type 
        amount
        buyerFee
        description
        createdByName
        createdOn
        feeEstimate { 
          acceptedByString
          acceptMethod
        } 
        asset { id, name, lastSix, listings, seller {id}}
        saleAsset { id, lotNumber, sale { saleOn } }
      }
      sellFeesCount
      sellFeesAmount
      sellFeesExpenses
      sellFeesNet
      sellFeesPercentage
      sellFees { 
        type 
        amount
        buyerFee
        description
        createdByName
        createdOn
        feeEstimate { 
          acceptedByString
          acceptMethod
        } 
        asset { id, name, lastSix, listings, seller {id}}
        saleAsset { id, lotNumber, sale { saleOn } }
      }

      transFeesCount
      transFeesAmount
      transFeesExpenses
      transFeesNet
      keyFeesCount
      keyFeesAmount
      keyFeesExpenses
      keyFeesNet
      reconFeesCount
      reconFeesAmount
      reconFeesExpenses
      reconFeesNet
      mechFeesCount
      mechFeesAmount
      mechFeesExpenses
      mechFeesNet

      insFeesCount
      insFeesAmount
      insFeesExpenses
      insFeesNet

      otherFeesCount
      otherFeesAmount
      otherFeesExpenses
      otherFeesNet

      storageFeesCount
      storageFeesAmount
      storageFeesExpenses
      storageFeesNet

      listFeesCount
      listFeesAmount
      listFeesExpenses
      listFeesNet

      bailoutFeesCount
      bailoutFeesAmount
      bailoutFeesExpenses
      bailoutFeesNet

      finFeesCount
      finFeesAmount
      finFeesExpenses
      finFeesNet
    }
  }
`;
